import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {ButtonComponent, FormCheckboxComponent, FormComponent, InputComponent} from "@Components/Forms";

import iconCheck from "@Icons/SVG/icon-check.svg";
import "./index.scss";
import {InputComponentStatusType} from "@Components/Forms/Inputs/Input/types";
import isEmail from "validator/lib/isEmail";
import {ReactSVG} from "react-svg";
import {UseQyvoUser} from "@Store/@Hooks";
import {UseUserSignInAction} from "@Store/@Hooks/@@Actions";

export const HomePageSignUpForm:React.FC = () => {


    const [firstName, setFirstName] = useState('');
    const [firstNameStatus, setFirstNameStatus] = useState<null | InputComponentStatusType>(null);

    const [lastName, setLastName] = useState('');
    const [lastNameStatus, setLastNameStatus] = useState<null | InputComponentStatusType>(null);

    const [emailAddress, setEmailAddress] = useState('');
    const [emailAddressStatus, setEmailAddressStatus] = useState<null | InputComponentStatusType>(null);

    const [userPassword, setUserPassword] = useState('');
    const [userPasswordStatus, setUserPasswordStatus] = useState<null | InputComponentStatusType>(null);
    const [userPasswordConfirmation, setUserPasswordConfirmation] = useState('');
    const [userPasswordConfirmationStatus, setUserPasswordConfirmationStatus] = useState<null | InputComponentStatusType>(null);

    const [submitSignUpFormStatus, setSubmitSignUpFormStatus] = useState(false);
    const [submitSignUpFormRequestStatus, setSubmitSignUpFormRequestStatus] = useState(false);

    const [regulationsAcceptation, setRegulationsAcceptation] = useState(false);
    const [regulationsAcceptationStatus, setRegulationsAcceptationStatus] = useState<null | InputComponentStatusType>(null);


    useEffect(() => {
        return () => {
            setFirstName('');
            setFirstNameStatus(null)
            setLastName('');
            setLastNameStatus(null);
            setEmailAddress('');
            setEmailAddressStatus(null);
            setUserPassword('');
            setUserPasswordStatus(null);
            setUserPasswordConfirmation('');
            setUserPasswordConfirmationStatus(null);
            setSubmitSignUpFormStatus(false);
            setSubmitSignUpFormRequestStatus(false);
            setRegulationsAcceptation(false);
            setRegulationsAcceptationStatus(null);
        };
    }, []);

    const firstNameSetter = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 1) {
            setFirstNameStatus({type: 'success', message: ''});
        } else {
            setFirstNameStatus({type: 'error', message: 'Name is too short'});
        }
        setFirstName(value);
    };

    const lastNameSetter = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 1) {
            setLastNameStatus({type: 'success', message: ''});
        } else {
            setLastNameStatus({type: 'error', message: 'Name is too short'});
        }
        setLastName(value);
    };

    const emailAddressSetter = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (isEmail(value)) {
            setEmailAddressStatus({type: 'success', message: ''});
        } else {
            setEmailAddressStatus({type: 'error', message: 'Email is not valid'});
        }
        setEmailAddress(value);
    };

    const userPasswordSetter = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value.length > 7) {
            setUserPasswordStatus({type: 'success', message: ''});
        } else {
            setUserPasswordStatus({type: 'error', message: 'Password is too short'});
        }
        setUserPassword(value);
    };

    const userPasswordConfirmationSetter = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value === userPassword) {
            setUserPasswordConfirmationStatus({type: 'success', message: ''});
        } else {
            setUserPasswordConfirmationStatus({type: 'error', message: 'Passwords are not equal'});
        }
        setUserPasswordConfirmation(value);
    };

    const changeRegulationsAcceptationStatus = () => {
        if (!regulationsAcceptation) {
            setRegulationsAcceptationStatus(null);
        }
        setRegulationsAcceptation(!regulationsAcceptation);
    };

    const signUpFormSubmitHandler = () => {

        let error = false;

        if (firstName.length > 1) {
            setFirstNameStatus({type: 'success', message: ''});
        } else {
            error = true;
            setFirstNameStatus({type: 'error', message: 'Name is too short'});
        }

        if (lastName.length > 1) {
            setLastNameStatus({type: 'success', message: ''});
        } else {
            error = true;
            setLastNameStatus({type: 'error', message: 'Name is too short'});
        }

        if (isEmail(emailAddress)) {
            setEmailAddressStatus({type: 'success', message: ''});
        } else {
            error = true;
            setEmailAddressStatus({type: 'error', message: 'Email is not valid'});
        }

        if (!regulationsAcceptation) {
            error = true;
            setRegulationsAcceptationStatus({type: 'error', message: 'You need to accept terms of service and privacy policy'});
        }

        // if (userPassword.length < 8) {
        //     error = true;
        //     setUserPasswordStatus({type: 'error', message: 'Password is too short'});
        // }
        //
        // if (userPassword !== userPasswordConfirmation) {
        //     error = true;
        //     setUserPasswordConfirmationStatus({type: 'error', message: 'Passwords are not equal'});
        // }

        if (error) {
            return;
        }

        signUpFormRequestHandler();

    };


    const signUpFormRequestHandler = async () => {

        const formData = new FormData();

        let userRegistrationAffiliate = localStorage.getItem('user_registration_affiliate');

        formData.append('email', emailAddress);
        formData.append('name', firstName);
        formData.append('surname', lastName);


        // formData.append('user_password', userPassword);
        // formData.append('user_registration_affiliate', userRegistrationAffiliate ?? '0');

        try {
            const response = await fetch(
                'https://qyvo-engine.webpros.pl/api/v1/qyvo-users/user-pre-registration/',
                { method: 'POST', body: formData }
            );
            if (response.ok) {
                setSubmitSignUpFormStatus(true);
                setSubmitSignUpFormRequestStatus(true);
                localStorage.removeItem('user_registration_affiliate');
            }
        } catch (e) {
            console.error(e);
        }

    };


    return (
        <Col xs={12} xl={6} className={'home-page__sign-up-form__sign-up-form'}>
            <Row className={'home-page__sign-up-form__sign-up-form__content'}>
                <FormComponent>

                    {!submitSignUpFormStatus &&
                    <InputComponent
                        value={firstName} setValue={firstNameSetter}
                        status={firstNameStatus}
                        lg={6}
                        label={'First Name'}
                        required={true} disabled={submitSignUpFormRequestStatus}
                        cssClasses={['sign-up-form-first-name']}
                    />
                    }

                    {!submitSignUpFormStatus &&
                    <InputComponent
                        value={lastName} setValue={lastNameSetter}
                        status={lastNameStatus}
                        lg={6}
                        label={'Last Name'}
                        required={true} disabled={submitSignUpFormRequestStatus}
                        cssClasses={['sign-up-form-last-name']}
                    />
                    }

                    {!submitSignUpFormStatus &&
                    <InputComponent
                        value={emailAddress} setValue={emailAddressSetter}
                        status={emailAddressStatus}
                        label={'E-mail address'}
                        required={true} disabled={submitSignUpFormRequestStatus}
                    />
                    }

                    {/*{!submitSignUpFormStatus &&*/}
                    {/*<InputComponent*/}
                    {/*    value={userPassword} setValue={userPasswordSetter}*/}
                    {/*    type={'password'}*/}
                    {/*    status={userPasswordStatus}*/}
                    {/*    label={'Password'}*/}
                    {/*    required={true} disabled={submitSignUpFormRequestStatus}*/}
                    {/*/>*/}
                    {/*}*/}

                    {/*{!submitSignUpFormStatus &&*/}
		            {/*    <InputComponent*/}
			        {/*        value={userPasswordConfirmation} setValue={userPasswordConfirmationSetter}*/}
			        {/*        type={'password'}*/}
			        {/*        status={userPasswordConfirmationStatus}*/}
			        {/*        label={'Repeat Password'}*/}
			        {/*        required={true} disabled={submitSignUpFormRequestStatus}*/}
		            {/*    />*/}
                    {/*}*/}

                    {!submitSignUpFormStatus &&
                    <Col xs={12} className={'sign-up-form-submit'}>
                        <ButtonComponent
                            type={'cta'}
                            size={'l'}
                            text={'Sign Up'}
                            callback={signUpFormSubmitHandler}
                            buttonDisabled={submitSignUpFormRequestStatus}
                        />
                    </Col>
                    }

                    {submitSignUpFormStatus &&
                    <Col xs={12} className={'sign-up-form-message'}>
                        <ReactSVG src={iconCheck} wrapper={'span'} className={'element-icon'} />
                        <span>Email has been registered</span>
                    </Col>
                    }

                    {!submitSignUpFormStatus && <>
                    <FormCheckboxComponent
                        labelText={`
                            I have read and agree to Qyvo\'s 
                            <a href="https://useqyvo.com/terms-of-service" target="_blank" rel="nofollow"><strong>Terms of Service</strong></a> and 
                            <a href="https://useqyvo.com/privacy-policy" target="_blank" rel="nofollow"><strong>Privacy Policy</strong><a/>.
                        `}
                        checkedStatus={regulationsAcceptation}
                        checkedStatusHandler={changeRegulationsAcceptationStatus}
                        requiredStatus={true}
                    />
                    {regulationsAcceptationStatus?.message &&
                    <span className={'regulations-error'}>{regulationsAcceptationStatus?.message}</span>
                    }
                    </>}

                </FormComponent>
            </Row>
        </Col>
    );

};


export default HomePageSignUpForm;
